// ==========================
// Version 2 - mintWithPinata.js
// - Pinata-first IPFS uploader for BWK NFT image + metadata
// - Sends the rendered PNG to a Firebase Function so Pinata secrets stay server-side
// ==========================

import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase';

const FUNCTIONS_REGION = 'europe-west2';

const functions = getFunctions(app, FUNCTIONS_REGION);
const uploadMemoryNftToIpfsFunction = httpsCallable(functions, 'uploadMemoryNftToIpfs');

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error || new Error('Could not read NFT image blob.'));
    reader.readAsDataURL(blob);
  });
}

export async function uploadMemoryNftToIpfs({
  imageBlob,
  memory,
  memoryId,
  ownerUid,
  network = 'polygon-amoy',
  minterAddress = null,
  externalBaseUrl = 'https://bwk.app',
}) {
  if (!imageBlob) {
    throw new Error('uploadMemoryNftToIpfs (Pinata): imageBlob is required');
  }
  if (!memory) {
    throw new Error('uploadMemoryNftToIpfs (Pinata): memory is required');
  }
  if (!memoryId) {
    throw new Error('uploadMemoryNftToIpfs (Pinata): memoryId is required');
  }
  if (!ownerUid) {
    throw new Error('uploadMemoryNftToIpfs (Pinata): ownerUid is required');
  }

  console.log('[BWK][IPFS] Uploading NFT assets through Firebase Function...');

  const imageDataUrl = await blobToDataUrl(imageBlob);
  const result = await uploadMemoryNftToIpfsFunction({
    imageDataUrl,
    memoryId,
    network,
    minterAddress: minterAddress || null,
    externalBaseUrl,
  });

  const data = result?.data || {};
  const { tokenUri, imageCid, metadataCid, metadata, provider, gatewayBase, mirror } = data;

  if (!tokenUri || !imageCid || !metadataCid || !metadata) {
    throw new Error('IPFS upload function returned an incomplete response.');
  }

  console.log('[BWK][IPFS] Function upload complete:', { imageCid, metadataCid, provider });

  return {
    tokenUri,
    imageCid,
    metadataCid,
    metadata,
    provider: provider || 'pinata',
    gatewayBase: gatewayBase || 'https://gateway.pinata.cloud/ipfs/',
    mirror: mirror || null,
  };
}

// ==========================
// End Version 2 - mintWithPinata.js
// ==========================
